import styled from 'styled-components';

import {
    spaceMixin,
} from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

export const StyledHR = styled(HR)`
    opacity: 0.4;
    margin: ${spaceMixin('lg')} 0;
`;
